import { render, staticRenderFns } from "./Showmore.vue?vue&type=template&id=36529ca8&scoped=true&"
import script from "./Showmore.vue?vue&type=script&lang=js&"
export * from "./Showmore.vue?vue&type=script&lang=js&"
import style0 from "./Showmore.vue?vue&type=style&index=0&id=36529ca8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36529ca8",
  null
  
)

export default component.exports